import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';

const TrimInfo = styled.div.attrs(({ dictionary }) => ({
    children: dictionary.clip_trimming_info || 'Clips can be trimmed based on the increments shown on the progress bar above. Increments are typically about 6 seconds.',
}))`
      color: ${COLORS.mlbGrey3};
      font-size: 11px;
      padding-top: 35px;
      line-height: normal;
      text-align: center;

      ${media.mdmin`
          font-size: 14px;
          padding-top: 20px;
      `}
  `;

TrimInfo.propTypes = {
    dictionary: PropTypes.object.isRequired,
};

export default TrimInfo;
